var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import { omit } from "lodash";
import id from "@irati/utils/id";
import FocusOnKeyboard from "../helpers/FocusOnKeyboard";
import Icon from "../../Icon";
var StyledIcon = styled(Icon).attrs({ size: 16 })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var IconButton = function (props) {
    var iconProps = omit(props, ["id", "onClick", "className"]);
    var idNamespace = id("icon-button", props);
    return (React.createElement(FocusOnKeyboard, __assign({}, props, { id: idNamespace }),
        React.createElement(StyledIcon, __assign({}, iconProps, { id: id("icon", idNamespace) }))));
};
IconButton.defaultProps = {
    className: null,
    inline: false
};
// https://styled-components.com/docs/advanced#referring-to-other-components
export default styled(IconButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
